import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import Footer from "./components/Footer";
import FormLayout from "./components/FormLayout";
import Header from "./components/Header";
import Layout from "./components/Layout";

function App() {
	return (
		<>
			<BrowserRouter>
				<Routes>
					<Route
						path="/"
						element={
							<>
								<Header />
								<Layout />
								<Footer />
							</>
						}
					></Route>
					<Route
						path="/form"
						element={
							<>
								<Header />
								<FormLayout />
								<Footer />
							</>
						}
					/>
				</Routes>
			</BrowserRouter>
		</>
	);
}

export default App;
